import React, { useEffect, useState } from "react";
import "../../assets/styles/styles.scss";
import Metadata from "../../components/Metadata";
import Header from "../../components/dashboard/Header";
import Menu from "../../components/dashboard/Menu";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../config/firebase";
import { Spin, Input, Select, List, Tag, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

const { Search } = Input;
const { Option } = Select;

export default function PublicAppUsers() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [usersData, setUsersData] = useState({
    patients: [],
    pharmacies: [],
    drivers: [],
  });
  const [category, setCategory] = useState(location.state?.category || "patients");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      const fetchCollection = async (profileType) => {
        const q = query(
          collection(db, "medicationUsers"),
          where("profileType", "==", profileType)
        );
        const snap = await getDocs(q);
        return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      };

      const [patients, pharmacies, drivers] = await Promise.all([
        fetchCollection("patient"),
        fetchCollection("pharmacy"),
        fetchCollection("driver"),
      ]);

      setUsersData({ patients, pharmacies, drivers });
      setLoading(false);
    }

    fetchData();
  }, []);

  const handleCategoryChange = (value) => setCategory(value);
  const handleSearchChange = (e) => setSearch(e.target.value);

  const handleUserClick = (id) => {
    navigate(`/admin/public-app-users/${id}`);
  };

  if (loading) return <Spin tip="Chargement..." />;

  const filteredList = usersData[category].filter((user) => {
    if (category === "pharmacies") {
      return user.pharmacyName?.toLowerCase().includes(search.toLowerCase());
    }
    return (
      `${user.firstName} ${user.lastName}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  });

  return (
    <>
      <h2 className="dashboard-title" style={{ marginBottom: 20 }}>
        Liste des utilisateurs
      </h2>

      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <Select
          defaultValue={category}
          onChange={handleCategoryChange}
          style={{ width: 200 }}
        >
          <Option value="patients">Utilisateurs</Option>
          <Option value="pharmacies">Pharmacies</Option>
          <Option value="drivers">Livreurs</Option>
        </Select>

        <Search
          placeholder="Rechercher..."
          onChange={handleSearchChange}
          value={search}
          style={{ flex: 1 }}
          allowClear
        />
      </div>

      <List
        bordered
        dataSource={filteredList}
        pagination={{ pageSize: 10 }}
        renderItem={(user) => (
          <List.Item
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
            onClick={() => handleUserClick(user.id)}
          >
          {user.files?.avatar ? (
            <img
              src={user?.files?.avatar || "/default-avatar.png"}
              alt="avatar"
              style={{ width: 50, height: 50, borderRadius: "50%" }}
            />
          ) : (
            <Avatar
              icon={<UserOutlined />}
              size={50}
              style={{ backgroundColor: "#87d068" }}
            />
          )}
            <div style={{ flex: 1 }}>
              {category === "pharmacies" ? (
                <>
                  <span style={{ fontWeight: 600 }}>{user.pharmacyName}</span>
                  <div style={{ color: "#555", fontSize: 12, margin: 0 }}>
                    {user.email}
                  </div>
                </>
              ) : (
                <>
                  <span style={{ fontWeight: 600 }}>
                    {user.firstName} {user.lastName}
                  </span>
                  <div style={{ color: "#555", fontSize: 12, margin: 0 }}>
                    {user.email}
                  </div>
                </>
              )}
              {user.status === "requested" && (
                <Tag color="orange" style={{ marginLeft: 8 }}>
                  En attente
                </Tag>
              )}
            </div>
          </List.Item>
        )}
      />
    </>
  );
}
